import React, { useState } from "react";
import { StackedContainer } from "@poseidon/ui/styles/layout";
import { getFunctions, httpsCallable } from "firebase/functions";
import { Button, Typography } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import MenuItem from "@mui/material/MenuItem";
import { Select } from "formik-mui";
import { CreateUserSchema } from "@poseidon/utils/authFieldUtils";
import ToasterMessage from "@poseidon/ui/components/ToasterMessage";

const functions = getFunctions();
const createNewUser = httpsCallable(functions, "createNewUser");

export default function CreateUser() {
  const [error, setError] = useState();
  const [notification, setNotification] = useState({
    open: false,
    message: "",
  });

  return (
    <StackedContainer>
      <Typography pl={1} mt={2} variant="h6">
        Create User
      </Typography>

      <Formik
        initialValues={{
          email: "",
          userType: "",
        }}
        validationSchema={CreateUserSchema}
        onSubmit={async (values, { resetForm }) => {
          try {
            createNewUser(values);
            resetForm();
            setNotification({
              open: true,
              message: "Successfully created user",
            });
          } catch (error) {
            setError(error.code);
          }
        }}
      >
        {({ errors, touched, isSubmitting }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              width: "100%",
              minWidth: "400px",
            }}
          >
            <Field
              component={TextField}
              name="email"
              label="Email"
              margin="dense"
              helperText={errors.email && "Email required"}
              error={errors.email && touched.email ? true : false}
              sx={{
                mb: 2,
              }}
            />
            <Field
              component={Select}
              sx={{
                mb: 2,
              }}
              id="userType"
              name="userType"
              labelId="userType"
              label="User Type"
            >
              <MenuItem value="admin">Admin</MenuItem>
              <MenuItem value="dealer">Dealer</MenuItem>
              <MenuItem value="sailor">Sailor</MenuItem>
            </Field>
            {error && <Typography color="error">{error}</Typography>}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              margin="normal"
            >
              Submit
            </Button>
          </Form>
        )}
      </Formik>
      <ToasterMessage
        open={notification.open}
        setOpen={(newState) =>
          setNotification({ ...notification, open: newState })
        }
        message={notification.message}
      />
    </StackedContainer>
  );
}
